export interface AddressBlockProps {
  street?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  emptyLabel?: string;
}

export function AddressBlock({
  street,
  city,
  state,
  postalCode,
  country,
  emptyLabel = 'No address on file.',
}: AddressBlockProps) {
  const cityLine = [city, state, postalCode].filter(Boolean).join(', ');

  if (!street && !cityLine && !country) {
    return <span className="text-muted-foreground text-xs italic">{emptyLabel}</span>;
  }

  return (
    <div className="flex flex-col text-xs">
      {street && <span className="font-semibold text-foreground">{street}</span>}
      {cityLine && <span className="text-muted-foreground">{cityLine}</span>}
      {country && <span className="text-muted-foreground">{country}</span>}
    </div>
  );
}
